import { create } from "zustand";
import { axiosHelper, tokenHelper } from "../helpers";
import { filterNonFalseValues } from "../helpers/Utlis";

export const useMenuItemsStore = create((set, get) => ({
  items: [],
  catalog: [],
  allTags: [],
  pagination: null,
  isLoading: false,
  isError: false,
  error: undefined,
  currency: "",
  image_url: "",
  menuName: "",
  menuNameAr: "",
  filters: {
    code: "",
    DestProv: "",
    dateFrom: "",
    dateTo: "",
    access: "",
    driverId: "",
    charger: false,
  },
  // Methods
  createItem: async (menuid, body) => {
    set({ isLoading: true });

    try {
      // Get the access token
      const accessToken = await tokenHelper.getToken();

      // Post the site creation request
      const response = await axiosHelper.post("/menu-item", body, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": undefined,
        },
      });

      //   // Refresh the list of sites
      await get().getItems(menuid);
      set({ isLoading: false });

      return true;
    } catch (e) {

      set({ isLoading: false });

      return false;
    } finally {
      set({ isLoading: false });
    }
  },
  getItems: async (menuId, page = 1, perPage = 10, search = "") => {
    try {
      const accessToken = await tokenHelper.getToken();
      set({ isLoading: true });

      const params = new URLSearchParams({ page, perPage });
      if (search && search.trim() !== "") {
        params.append("search", search.trim());
      }

      let response = await axiosHelper.get(
        `/menu/portal/${menuId}?${params.toString()}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      console.log("DEBUG LOG: response.data");
      console.log(response.data);

      set({
        currency: response.data.currency,
        image_url: response.data.image_url,
        menuName: response.data.name,
        menuNameAr: response.data.name_ar,
        items: response.data.menu_items,
        isLoading: false,
        pagination: response.data.pagination,
      });
    } catch (e) {
      console.log(e);
    } finally {
      set({ isLoading: false });
    }
  },
  updateItem: async (menuid, id, info) => {
    try {
      const accessToken = await tokenHelper.getToken();


      set({ isLoading: true });
      let response = await axiosHelper.patch(`/v2/menu-item/${id}`, info, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": undefined,
        },
      });
      get().getItems(menuid);
      return response;
    } catch (e) {
      console.log(e);
      throw e;
    } finally {
      set({ isLoading: false });
    }
  },
  deleteItem: async (menuid, id) => {
    try {
      const accessToken = await tokenHelper.getToken();


      set({ isLoading: true });
      let response = await axiosHelper.delete(`/menu-item/${id}`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      // 
      get().getItems(menuid);
    } catch (e) {
      console.log(e);
    } finally {
      set({ isLoading: false });
    }
  },

  getCatalog: async () => {
    try {
      const accessToken = await tokenHelper.getToken();
      set({ isLoading: true });

      let response = await axiosHelper.get(`/menu-item/catalog/list`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });



      set({
        catalog: response.data,
        isLoading: false,
      });
    } catch (e) {
      console.log(e);
    } finally {
      set({ isLoading: false });
    }
  },
  setFilters: (filters) => {
    set({ filters: filterNonFalseValues(filters) });
  },
  executeItemsOrdering: async (orderedData) => {
    try {
      const accessToken = await tokenHelper.getToken();
      set({ isLoading: true });
      let response = await axiosHelper.post(`/menu-item/ordering`, { ordering: orderedData }, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      return true;
    } catch (e) {
      console.log(e);
      return false;
    } finally {
      set({ isLoading: false });
    }
  },
  fetchAllTags: async () => {
    try {
      const accessToken = await tokenHelper.getToken();
      let response = await axiosHelper.get(`/menu-item/tags/all`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      set({ allTags: response.data || [] });
    } catch (e) {
      console.log(e);
    }
  },

  bulkAddItems: async (menuId, items) => {
    try {
      const accessToken = await tokenHelper.getToken();
      set({ isLoading: true });
      const data = await axiosHelper.post(
        `/menu/${menuId}/items/bulk`,
        { items },
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      await get().getItems(menuId);
      return data;
    } catch (e) {
      console.log(e);
      throw e;
    } finally {
      set({ isLoading: false });
    }
  },
}));
